module.exports = (__webpack_public_path__ || '') + "static/images/android-chrome-512x512-9cdbef075e3b916a4ee6d21865fdf02d.png";